import React, { Component } from "react";
import "./Action.styles.scss";
// import axios from "axios";

// import cross from "../assets/cross.svg"
// import plus from "../assets/plus.svg"
import { Icon } from "react-materialize";

import Dropdown from "../Dropdown/Dropdown";

export default class Action extends Component {
  constructor() {
    super();
    this.state = {
      button: false,
      // mdo_list: [],
      visible: false,
    };
  }
  componentDidMount() {
    // this.getData();
    // console.log(`CDM at action`)
  }

  handleButtonClick = () => {
    this.setState({ visible: !this.state.visible });
  };

  // getData = () => {
  //   axios
  //     .get(
  //       `${process.env.REACT_APP_API_URL}/api/admin_panel/v1/mdo-list?include=all`,
  //       {
  //         headers: {
  //           Authorization:
  //             "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       let filteredMdo = res.data.data.filter(
  //         (mdo) => mdo.id !== this.props.mdoid
  //       )
  //       this.setState({ mdo_list: filteredMdo })
  //     })
  // }
  render() {
    return (
      <div className="actionx-container">
        <div className="select">
          {this.state.visible ? (
            <Dropdown
              title="Add MDO"
              items={this.props.mdoList}
              onChange={this.props.handleMDOSelect}
            />
          ) : null}
        </div>
        <div
          className={`hide-show-btn ${this.state.visible ? `close` : `open`}`}
          onClick={this.handleButtonClick}
        >
          {this.state.visible ? (
            <Icon className="close">close</Icon>
          ) : (
            <Icon>add</Icon>
          )}
        </div>
      </div>
    );
  }
}
